import React from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import VipBadge from '../VipBadge';
import styles from './index.module.scss';

interface BatchCenterContentProps {
  count: number;
  total: number;
  isProcessingMode?: boolean;
  selectedCount?: number;
  showVipBadge?: boolean;
}

export function BatchCenterContent({
  count,
  total,
  isProcessingMode = false,
  selectedCount = 0,
  showVipBadge = false,
}: BatchCenterContentProps) {
  const languageStore = useLanguageStore((state) => state.languageStore);

  if (isProcessingMode) {
    return (
      <div className={styles.centerContent}>
        <span className={styles.label}>{languageStore.smartcatTranslationText((v) => v.num_selected)}</span>
        <span className={styles.count}>
          {selectedCount}
          /
          {count}
        </span>
      </div>
    );
  }

  return (
    <div className={styles.centerContent}>
      <IconFont name="layerBold" fontSize={18} className={styles.layerIcon} />
      <span className={styles.label}>
        {languageStore.smartcatTranslationText((v) => v.batch_edit)}
      </span>
      <span className={styles.count}>
        {count}
        /
        {total}
      </span>
      {showVipBadge && <VipBadge className={styles.vipBadge} />}
    </div>
  );
}
